import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Pagination } from "react-bootstrap";

function EmailStatistics() {
  const [EmailStatistics, setEmailStatistics] = useState([]);
  const [loader, setLoader] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
     const [fromDate, setFromDate] = useState("");
      const [toDate, setToDate] = useState("");
    const token = JSON.parse(localStorage.getItem("data")).token;

  const navigate = useNavigate();
const formatDateToYMD = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  // Set default dates on mount
  useEffect(() => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const today = new Date();
    setFromDate(formatDateToYMD(firstDay));
    setToDate(formatDateToYMD(today));
  }, []);

  // Fetch data when filters change
  useEffect(() => {
    setCurrentPage(0);
  }, [fromDate, toDate]);

  useEffect(() => {
    getData(currentPage);
  }, [currentPage, fromDate, toDate]);

  const getData = async (pageNumber = 0) => {
    try {
      setLoader(true);
      const payload = {fromDate, toDate };
      const response = await axios.post(
        "/api/email-statistics/getAllEmailStatistics",
        payload,
        {
          params: { page: pageNumber },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
        setEmailStatistics(response.data.content);
        setCurrentPage(response.data.number);
        setTotalPages(response.data.totalPages);
  
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };

  useEffect(() => {
    getData(currentPage); 
  }, []);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
      getData(newPage);
  };

  
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      <div>
        <Dashboard />
      </div>
      {loader && <div className="loading"></div>}
      <div>
        <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
          <div className="card card-raised">
            <div className="card-body">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                Email Statistics
              </div>

              <div className="d-flex flex-wrap align-items-center mb-3">
              <div className="me-3">
                <label>From Date:</label>
                <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
              </div>
              <div>
                <label>To Date:</label>
                <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
              </div>
            </div>

              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                    <th>Date Time</th>
                    <th>To Recipient</th>
                    <th>CC Recipients</th>
                    <th>Message Id</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {EmailStatistics.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    EmailStatistics.map((stats, index) => (
                      <tr key={stats.id}>
                        <td>{index + 1}</td>
                        <td>{stats.dateTime}</td>
                        <td>{stats.toRecipient}</td>
                        <td>{stats.ccRecipient}</td>
                        <td>{stats.msgId}</td>
                        <td>{stats.status}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
                        <div className="d-flex justify-content-center">
                            <Pagination>
                              <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                              <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                              {renderPageNumbers()}
                              <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                              <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                            </Pagination>
                          </div>

             </div>
          </div>
        </div>
        {loader && <div className="loading"></div>}
      </div>
    </div>
  );
}

export default EmailStatistics;
